<template>
<!-- 平台简介 -->
<div class="brief">

	<!-- 头部 -->
	<zmlmenupage cn-name='平台简介' en-name='Platform Introduction'></zmlmenupage>

	<zmlpagebanner banner-img='static/img/proBanner.png' banner-text='货运江湖，一键启航！' cn-name='产品中心' en-name='Product Center'>
	</zmlpagebanner>

	<!-- 平台简介 -->
	<div class="brief-service">
		<div class="info  brief-service-info">
			<div class="brief-title">平台简介</div>
			<div class="brief-service-box flexBetween">
				<div class="brief-service-left">
					<div class="brief-service-title">
						<p><span>值得信赖</span>的</p>
						<p>运单交易结算工具</p>
					</div>
					<p>货运江湖平台使用物流交易大数据所形成的的智能配对算法，根据不同船东、司机的历史运输数据计算合理运价，给托运人提供运价依据，通过大数据和云计算，匹配货源和船舶、车辆信息，快速达成运输交易。提升运输效能和返程效率，降低整体物流运输成本。平台有建立健全的信用评价体系，同时保障双方权益，让货主和船东、司机双方的需求和服务对称，货主无忧发货，船东、司机无忧承运。</p>
				</div>
				<div class="brief-item-img-1">
					<img src="../../static/img/WechatIMG198.png" alt=""/>
				</div>
				<!-- <zmlservicebanner class="brief-swiper"></zmlservicebanner> -->
			</div>
		</div>
	</div>

	<div class="brief-service">
		<div class="info  brief-service-info">
			<div class="brief-service-box2 flexBetween">
				<div class="brief-item-img-1">
					<img src="../../static/img/trading-2.jpg" alt=""/>
				</div>
				<div class="brief-service-left2">
					<div class="brief-service-title">
						<p><span>划时代</span>的</p>
						<p>行业信用体系</p>
					</div>
					<div class="brief-service-words">
					<div>
						<p class="zmlcolor1">物流运输业正在从传统的熟人经济走向未来</p>
						<p>在货运江湖，我们将严格审核所有入驻企业与 船东、司机资质,优质用户将获得平台信用积分与交易信用额度,让陌生交易不再畏首畏尾，运力与生意流通起来。
						通过货运江湖完成的运输交易，在货主生成订单时，运费便被平台锁定进入监管账户；运输过程平台全程跟进，有问题及时协调反馈；运输结束后，双方确认运单完成，船东、司机运费即刻到账。</p>
					</div>
				</div>
				<div class="brief-service-li">
					<ul>
						<li>银行运费预存监管，立即结算，纠纷更少</li>
						<li>车辆/船舶/货主严审，降低风险隐患</li>
						<li>建立健全的信用体系，让生意变简单</li>
						<li>零资金池，用户使用更安心</li>
					</ul>
				</div>				
			</div>
			</div>
		</div>
	</div>
	<div class="brief-service">
		<div class="info  brief-service-info">
			<div class="brief-service-box3 flexBetween">
				<div class="brief-service-left">
					<div class="brief-service-title">
						<p><span>懂你</span>的</p>
						<p>物流运输管理平台</p>
					</div>
					<div class="brief-service-words">
						<div>
							<p>专属的企业客服专员+即触即达的企业后台管理平台</p>
							<p>每月物流计划轻松做，“门到门”运输更便捷</p>
							<p>货运江湖，用互联网技术改造传统运输行业</p>
						</div>
					</div>
					<div class="brief-service-li">
						<ul>
							<li>高效链接 资源优化</li>
							<li>效率提升 助力产业升级</li>
						</ul>
					</div>				
			</div>
				<div class="brief-item-img-1">
					<img src="../../static/img/trading-3.png" alt=""/>
				</div>
			</div>
		</div>
	</div>


	<!-- <div class="brief-item flexBetween brief-item-1">
		<div class="brief-item-text">
			<div class="brief-service-title">
				<p><span>划时代</span>的</p>
				<p>行业信用体系</p>
			</div>
			<div class="brief-service-words">
				<div>
					<p class="zmlcolor1">物流运输业正在从传统的熟人经济走向未来</p>
					<p>在货运江湖，我们将严格审核所有入驻企业与 船东、司机资质</p>
					<p>优质用户将获得平台信用积分与交易信用额度</p>
					<p>让陌生交易不再畏首畏尾，运力与生意流通起来</p>
				</div>
				<div>
					<p>运费在货主生成订单时，平台锁定进入监管账户</p>
					<p>平台全程跟进，问题及时协调反馈。</p>
					<p>双方确认运单完成，船东、司机运费即刻到账；平台开具水陆运输发票</p>
				</div>
			</div>
			<div class="brief-service-li">
				<ul>
					<li>银行运费预存监管，立即结算，纠纷更少</li>
					<li>车辆/船舶/货主严审，降低风险隐患</li>
					<li>建立健全的信用体系，让生意变简单</li>
					<li>零资金池，用户使用更安心</li>
				</ul>
			</div>
		</div>
		<div class="brief-item-img">
			<img src="../../static/img/pro2.png" alt="">
		</div>
	</div> 
	<div class="brief-item flexBetween brief-item-2">
		<div class="brief-item-img">
			<img src="../../static/img/pro3.png" alt="">
		</div>
		<div class="brief-item-text">
			<div class="brief-service-title">
				<p><span>懂你</span>的</p>
				<p>物流运输管理平台</p>
			</div>
			<div class="brief-service-words">
				<div>
					<p>专属的企业客服专员+即触即达的企业后台管理平台</p>
					<p>每月物流计划轻松做，“门到门”运输更便捷</p>
					<p>货运江湖，用互联网技术改造传统运输行业</p>
				</div>
			</div>
			<div class="brief-service-li">
				<ul>
					<li>高效链接 资源优化</li>
					<li>效率提升 助力产业升级</li>
				</ul>
			</div>
		</div>
	</div>-->
	<!-- 运输流程-->
	<div class="brief-process-pc">
		<div class="info brief-process-info">
			<div class="brief-title2">运输流程</div>
			<div class="process-top">
				<div class="process-top-child">
					<img src="../../static/img/transport-1.png">
					<span class="process-top-text">01</span>
					<p class="process-top-title">发布货源</p>
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-2.png">
					<span class="process-top-text">02</span>
					<p class="process-top-title">生成订单</p>
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-3.png" style="width:150px;">
					<span class="process-top-text">03</span>
					<p class="process-top-title">船东/司机</p>
					<p class="process-top-title">接单</p>
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-4.png">
					<span class="process-top-text">04</span>
					<p class="process-top-title">生成运单</p>
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-5.png">
					<span class="process-top-text">05</span>
					<p class="process-top-title">装货签到</p>
					<!-- <p class="dot"></p><br/>
					<div class="process-top-child-line"></div> -->
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-6.png">
					<span class="process-top-text">06</span>
					<p class="process-top-title">运输途中</p>
					<!-- <p class="dot"></p> -->
				</div>
				<div class="process-top-line"></div>
				<div class="process-top-child">
					<img src="../../static/img/transport-7.png">
					<span class="process-top-text">07</span>
					<p class="process-top-title">卸货签到</p>
					<!-- <p class="dot"></p> -->
				</div>
			</div>
			<div>
				<div class="process-bottom">
					<div class="process-bottom-left">
						<div class="process-top-child">
							<img src="../../static/img/transport-8.png">
							<span class="process-top-text">08</span>
							<p class="process-top-title">货主签收</p>
						</div>
						<div class="process-top-line"></div>
						<div class="process-top-child">
							<img src="../../static/img/transport-9.png">
							<span class="process-top-text">09</span>
							<p class="process-top-title">运单完成</p>
						</div>
						<div class="process-top-line"></div>
						<div class="process-top-child">
							<img src="../../static/img/transport-10.png">
							<span class="process-top-text">10</span>
							<p class="process-top-title">平台开出</p>
							<p class="process-top-title">运输发票</p>
						</div>
						<div class="process-top-line"></div>
						<div class="process-top-child">
							<img src="../../static/img/transport-11.png">
							<span class="process-top-text">11</span>
							<p class="process-top-title">交易结束</p>
						</div>
					</div>
				</div>
			</div>
				<div class="process-bottom-right">
					<div class="process-bottom-right-platform">
						<div class="platform-left">
							<p class="dot"></p> <br/>
							<div class="process-top-child-line"></div>
						</div>
						<div class="platform-left-center">
							<p class="dot-2"></p> <br/>
							<div class="process-child-line-center"></div>
							<div class="process-img">
								<img src="../../static/img/platform.png">
								<p class="process-top-title">平台监控</p>
							</div>
						</div>
						<div class="platform-right">
							<p class="dot-3"></p> <br/>
							<div class="process-top-child-line-right"></div>
						</div>
					</div>
				</div>
		</div>
	</div>
	<!-- 以下移动端可见 -->
	<div class="phone-brief">
		<div class="phone-brief-swiper">
			<swiper ref="mySwiper" :options="swiperOptions">
				<swiper-slide>
					<img src="../../static/img/pro2.png" alt="">
					<div class="phone-brief-swiper-text">
						<p>无车承运人资质+无船承运人资质</p>
						<p>官方认可  真正安心</p>
					</div>
				</swiper-slide>
				<swiper-slide>
					<img src="../../static/img/pro3.png" alt="">
					<div class="phone-brief-swiper-text">
						<p>无车承运人资质+无船承运人资质</p>
						<p>官方认可  真正安心</p>
					</div>
				</swiper-slide>
				<swiper-slide>
					<img src="../../static/img/pro4.jpg" alt="">
					<div class="phone-brief-swiper-text">
						<p>无车承运人资质+无船承运人资质</p>
						<p>官方认可  真正安心</p>
					</div>
				</swiper-slide>
				<div class="swiper-pagination phone-service-page" slot="pagination" ref="briefPage"></div>
			</swiper>
		</div>
		<div class="phone-brief-box" style="background-color: #F4F4F6;">
			<div class="brief-title">平台简介</div>
			<div class="brief-service-left">
				<div class="brief-service-title">
					<p><span>值得信赖</span>的</p>
					<p>运单交易结算工具</p>
				</div>
				<p>传统航运业的革命性产业互联网升级，货运江湖奋勇前行！从此，将水运需求，与船舶运力在平台上进行匹配！货主通过APP对入驻船东进行选择，确立运输订单。船东接单后，按照平台管理规则进行订单运输。智能算法推荐就近船舶与货源，高效、经济！调节与降低珠江水系分段的运费与空载率！一个属于互联网航运业的伟大时代正在到来！</p>
			</div>
		</div>
		<div class="phone-brief-box">
			<img src="../../static/img/trading-2.jpg" alt="">
		</div>
		<div class="phone-brief-box">
			<div class="brief-item-text">
				<div class="brief-service-title">
					<p><span>划时代</span>的</p>
					<p>行业信用体系</p>
				</div>
				<div class="brief-service-words">
					<div>
						<p class="zmlcolor1">物流运输业正在从传统的熟人经济走向未来</p>
						<p>在货运江湖，我们将严格审核所有入驻企业与 船东、司机资质</p>
						<p>优质用户将获得平台信用积分与交易信用额度</p>
						<p>让陌生交易不再畏首畏尾，运力与生意流通起来</p>
					</div>
					<div>
						<p>运费在货主生成订单时，平台锁定进入监管账户</p>
						<p>平台全程跟进，问题及时协调反馈。</p>
						<p>双方确认运单完成，船东、司机运费即刻到账；平台开具水陆运输发票</p>
						<!-- <p class="zmlcolor1">5G智慧航运，让航运生意走进大未来</p> -->
					</div>
				</div>
				<div class="brief-service-li">
					<ul>
						<li>银行运费预存监管，立即结算，纠纷更少</li>
						<li>车辆/船舶/货主严审，降低风险隐患</li>
						<li>建立健全的信用体系，让生意变简单</li>
						<li>零资金池，用户使用更安心</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="phone-brief-box">
			<img src="../../static/img/trading-3.png" alt="">
		</div>
		<div class="phone-brief-box">
			<div class="brief-item-text">
				<div class="brief-service-title">
					<p><span>懂你</span>的</p>
					<p>水运物流管理平台</p>
				</div>
				<div class="brief-service-words">
					<div>
						<p>专属的企业客服专员+即触即达的企业后台管理平台</p>
						<p>每月物流计划轻松做，“门到门”运输更便捷</p>
						<p>货运江湖，用互联网技术改造传统运输行业</p>
					</div>
				</div>
				<div class="brief-service-li">
					<ul>
						<li>高效链接 资源优化</li>
						<li>效率提升 助力产业升级</li>
					</ul>
				</div>
			</div>
		</div>
	
	<!-- 以上移动端可见 -->

	<!-- 运输流程 -->
	<div class="brief-process">
		<div class="info brief-process-info">
			<div class="brief-title">运输流程</div>
			<div class="brief-process-content flex">
				<div class="brief-process-item">
					<p>01</p>
					<p>发布</p>
					<p>货源</p>
					<img src="../../static/img/transport-1.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>02</p>
					<p>生成</p>
					<p>订单</p>
					<img src="../../static/img/transport-2.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>03</p>
					<p>船东/司机</p>
					<p>接单</p>
					<img src="../../static/img/transport-3.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>04</p>
					<p>生成</p>
					<p>运单</p>
					<img src="../../static/img/transport-4.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item-platform">
				<div class="brief-process-item-monitoring">
					<p>05</p>
					<p>装货</p>
					<p>签到</p>
					<img src="../../static/img/transport-5.png" width="150" alt="">
				</div>
				<div class="brief-process-item-monitoring">
					<p>06</p>
					<p>运输</p>
					<p>途中</p>
					<img src="../../static/img/transport-6.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item-monitoring">
					<p>07</p>
					<p>卸货</p>
					<p>签到</p>
					<img src="../../static/img/transport-7.png" width="150" alt="">
				</div>
				</div>
				<div class="brief-process-item">
					<p>→↓</p>
					<p>平台</p>
					<p>监控</p>
					<img src="../../static/img/platform.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>08</p>
					<p>货主</p>
					<p>签收</p>
					<img src="../../static/img/transport-8.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>09</p>
					<p>运单</p>
					<p>完成</p>
					<img src="../../static/img/transport-9.png" width="150" alt="">
				</div>
				<div class="brief-process-point"><span></span></div>
				<div class="brief-process-item">
					<p>10</p>
					<p>平台开出</p>
					<p>运输发票</p>
					<img src="../../static/img/transport-10.png" width="150" alt="">
				</div>
				<div class="brief-process-item">
					<p>11</p>
					<p>交易</p>
					<p>结束</p>
					<img src="../../static/img/transport-11.png" width="150" alt="">
				</div>
			</div>
		</div>
	</div>
	</div>
	<gototop></gototop>
</div>
</template>
<script>
import zmlservicebanner from "@/components/serviceBanner.vue";
export default {
  name: "brief",
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        speed: 1500,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  components: {
    zmlservicebanner,
  },
  mounted() {
    this.$nextTick(() => {
      let phoneBrief = this.$refs.phoneBrief.offsetHeight;
      // console.log(phoneBrief);
      this.$refs.briefPage.style.bottom = phoneBrief + 10 + "px";
    });
    // chrome
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
  },
};
</script>
<style scoped="scoped">
.brief-service {
  width: 100%;
  height: auto;
  background-color: #f4f4f6;
  padding: 100px 0;
}

.brief-title {
  font-size: 28px;
  font-weight: bold;
}
.brief-title2 {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 40px;
}
.brief-service-box {
  width: 100%;
  /* height: 100%; */
  background-color: #fff;
  margin-top: 110px;
}

.brief-service-left {
  width: 680px;
  height: auto;
  padding: 90px 95px 50px 54px;
}

.brief-service-left > p {
  font-size: 16px;
  font-weight: 400;
  color: rgba(69, 69, 69, 1);
  line-height: 28px;
  margin-top: 60px;
}

.brief-service-title p {
  font-size: 54px;
  font-weight: bold;
  letter-spacing: 6px;
}

.brief-service-title p:nth-of-type(1) span {
  color: #127bfd;
}

.brief-service-right {
  margin-top: -110px;
}

.brief-service-right >>> .service-swiperText {
  padding: 50px 0 0 40px;
}

.brief-item {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 80px 0;
  position: relative;
}

.brief-item-text {
  width: 100%;
  padding-left: 331px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.brief-item-text > div {
  margin: 30px 0;
}

.brief-service-words > div {
  margin: 20px 0;
}

.brief-service-words > div p {
  color: #454545;
  line-height: 28px;
}

.brief-service-words > div .zmlcolor1 {
  color: #127bfd;
  font-weight: bold;
}

.brief-service-li ul li {
  list-style: disc;
  font-size: 20px;
  line-height: 34px;
  margin-left: 25px;
}

.brief-item-img {
}

.brief-item-1 .brief-item-img {
}

.brief-item-2 .brief-item-text {
  padding-left: 181px;
}

.brief-process {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 100px 0;
}

.brief-process-content {
  flex-wrap: wrap;
  padding: 0px 40px;
  margin-top: 50px;
}

.brief-process-item {
  width: 150px;
  height: auto;
  text-align: center;
  margin-bottom: 50px;
}

.brief-process-item p {
  font-size: 24px;
}

.brief-process-item p:nth-of-type(1) {
  color: #127bfd;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 5px;
}

.brief-process-point {
  padding-top: 15px;
  margin: 0 40px;
}

.brief-process-point span {
  display: block;
  width: 61px;
  height: 6px;
  background: rgba(222, 217, 217, 1);
  border-radius: 3px;
}

.brief-swiper {
  margin-top: -110px;
}

.phone-brief {
  display: none;
}

.brief-item-img-1 img {
  width: 100%;
  height: 100%;
}

.brief-service-box2 {
  background-color: #fff;
  margin-top: -50px;
}

.brief-service-box3 {
  background-color: #fff;
  margin-top: -50px;
}

.brief-service-left2 {
  width: 750px;
  height: auto;
  padding: 30px 50px 50px 54px;
}

.brief-process-pc {
  width: 100%;
  height: 620px;
  background-color: #fff;
  padding: 100px 0;
}
.brief-process-pc img {
  display: inline-block;
  width: 76px;
  height: 76px;
  vertical-align: bottom;
}

.process-top {
  display: flex;
  justify-content: space-around;
}

.process-top-child {
  display: inline-block;
}
.process-top-line {
  display: inline-block;
  height: 3px;
  width: 50px;
  background-color: rgb(202, 201, 201);
  margin-top: 50px;
}
.process-top-text {
  font-size: 30px;
  color: rgb(202, 201, 201);
}
.process-top-title {
  font-size: 28px;
}
.process-bottom {
  display: inline-block;
  width: 55%;
}
.process-bottom-left {
  display: inline-block;
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}

.process-bottom-right-platform {
  margin-top: -250px;
  margin-left: 61%;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(15, 46, 184);
  margin-left: 50px;
  margin-bottom: 0px;
}
.process-top-child-line {
  display: inline-block;
  width: 164px;
  height: 100px;
  border-left: 2px solid rgb(15, 46, 184);
  border-bottom: 2px solid rgb(15, 46, 184);
  margin-top: -6px;
  margin-left: 54px;
}
.platform-left-center {
  margin-top: -136px;
  margin-left: 48%;
}
.process-child-line-center {
  display: inline-block;
  width: 4px;
  height: 80px;
  border-left: 2px solid rgb(15, 46, 184);
  margin-top: -10px;
  margin-left: -2px;
}
.dot-2 {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(15, 46, 184);
  margin-left: -6px;
  margin-top: 20px;
}
.process-img {
  margin-left: -54px;
  margin-top: -20px;
}
.process-img img {
  display: inline-block;
  width: 106px;
  height: auto;
}
.platform-right {
  margin-top: -234px;
  margin-left: 47%;
}
.dot-3 {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(15, 46, 184);
  margin-left: 212px;
  margin-top: 20px;
}
.process-top-child-line-right {
  display: inline-block;
  width: 164px;
  height: 100px;
  border-right: 2px solid rgb(15, 46, 184);
  border-bottom: 2px solid rgb(15, 46, 184);
  margin-top: -6px;
  margin-left: 54px;
}

.brief-process-item-platform {
  display: flex;
  justify-content: space-around;
  width: 220px;
  height: auto;
  text-align: center;
  margin-bottom: 30px;
  border: 3px solid #127bfd;
}
.brief-process-item-monitoring {
  width: 150px;
  height: auto;
  text-align: center;
}

.brief-process-item-monitoring p {
  font-size: 24px;
}

.brief-process-item-monitoring p:nth-of-type(1) {
  color: #127bfd;
  font-weight: bold;
  font-size: 30px;
  /* margin-bottom: 5px; */
}
@media only screen and (max-width: 1600px) {
  .brief-item-text {
    padding: 0px 100px;
    width: 50%;
  }
  .brief-item-img {
    width: 50%;
    overflow: hidden;
  }
  .brief-process-info {
    /* width: 1400px; */
  }
}

@media only screen and (max-width: 1400px) {
  .brief-process-point {
    display: none;
  }
  .brief-process-item {
    /* flex: 1; */
    width: 20%;
  }
  .brief-process-item img {
    margin: auto;
  }
  .brief-service-left {
    padding: 60px 95px 50px 54px;
  }
}

@media only screen and (max-width: 750px) {
  .platform-border {
    border: 2px solid #ccc;
  }
  .brief-process-content img {
    display: inline-block;
    width: 46px;
    height: 46px;
  }
  .brief-process-pc {
    display: none;
  }
  .brief-service {
    padding-top: 0;
  }
  .brief-title {
    padding: 23px 0;
    font-size: 14px;
    font-weight: bold;
  }
  .brief-service,
  .brief-item {
    display: none;
  }
  .brief-process {
    padding-top: 0;
  }
  .brief-process-content {
    padding: 0;
    margin-top: 0;
  }
  .brief-process-point {
    display: none;
  }
  .brief-process-item {
    width: 25%;
    margin-bottom: 20px;
  }
  .brief-process-item img {
    /* width: 100% !important; */
  }
  .brief-process-item p {
    font-size: 12px;
  }
  .brief-process-item-monitoring p {
    font-size: 12px;
  }
  .phone-brief {
    width: 100%;
    height: auto;
    display: block;
  }
  .swiper-slide img {
    width: 100%;
  }
  .phone-brief-swiper-text {
    background-color: #fff;
    padding: 20px 60px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
  }
  >>> .swiper-pagination {
    bottom: auto;
    /* top: 65%; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  >>> .swiper-pagination-bullet {
    opacity: 1;
    background: #fff;
  }
  .phone-service-page >>> .swiper-pagination-bullet-active {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: url(../../static/img/active-point.png) no-repeat center;
    background-size: cover;
  }
  .phone-brief-box {
    padding: 20px 23px;
  }
  .phone-brief-box img {
    width: 100%;
  }
  .brief-service-left {
    padding: 0;
    width: 100%;
  }
  .brief-service-title p {
    font-size: 27px;
  }
  .brief-service-left > p {
    font-size: 14px;
    margin-top: 20px;
  }
  .brief-item-text {
    width: 100%;
    padding: 0;
  }
  .brief-item-text > div {
    margin: 15px 0;
  }
  .brief-service-words {
    font-size: 13px;
  }
  .brief-service-li ul li {
    font-size: 15px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/brief.vue